import { StoreState } from '../../store';

export const selectTrackingLinksByCreator = (creatorId: string) => (state: StoreState) => {
  const entry = state.trackingLinks?.TrackingLinksByCreator.find((e: { creatorId: string }) => e.creatorId === creatorId);
  return entry?.trackingLinks || [];
};

export const selectTrackingLinkLoading = (state: StoreState) => state.trackingLinks?.loading;
export const selectTrackingLinkError = (state: StoreState) => state.trackingLinks?.error;

// Build key helper
const keyOf = (creatorId?: string, status?: string) => `${creatorId || ''}__${status || 'active'}`;

export const selectTrackingLinksByCreatorAndStatus = (creatorId: string, status: string) => (state: StoreState) => {
  const key = keyOf(creatorId, status);
  const entry = state.trackingLinks?.trackingLinksByKey.find((e: { key: string }) => e.key === key);
  return entry || { key, items: [], page: 0, totalPages: 0 };
};

export const selectTrackingLinksLoadingByCreatorAndStatus = (creatorId: string, status: string) => (state: StoreState) => {
  const key = keyOf(creatorId, status);
  return state.trackingLinks?.loadingByKey[key];
};
